import { jsx, jsxs } from "react/jsx-runtime";
import { ClockIcon } from "@dion-web/ui-icons";
import { LocalizationProvider as LocalizationProviderMui } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useMemo } from "react";
import { notReachable } from "../../shared/helpers";
import { TimePickerStyled } from "./ui";
import { Typography, Stack, Icon } from "../../components";
const TimePicker = ({
  locale = "ru",
  className,
  header = "",
  type = "single-time",
  isTextField = true,
  ...props
}) => {
  const renderDatePicker = useMemo(
    () => {
      switch (type) {
        case "single-time":
          return /* @__PURE__ */ jsxs(Stack, { className, children: [
            header && isTextField && /* @__PURE__ */ jsx(Typography, { variant: "body2", marginBottom: "8px", children: header }),
            /* @__PURE__ */ jsx(
              TimePickerStyled,
              {
                timeSteps: { minutes: 1 },
                label: "",
                ampm: false,
                slots: { openPickerIcon: () => /* @__PURE__ */ jsx(Icon, { size: "l", icon: /* @__PURE__ */ jsx(ClockIcon, {}) }) },
                slotsProps: { field: { placeholder: "__:__" } },
                ...props
              }
            )
          ] });
        default:
          notReachable(type);
      }
    },
    [type, isTextField, locale, header, props]
  );
  return /* @__PURE__ */ jsx(
    LocalizationProviderMui,
    {
      dateAdapter: AdapterDayjs,
      adapterLocale: locale,
      children: renderDatePicker
    }
  );
};
TimePicker.displayName = "DatePicker";
var TimePicker_default = TimePicker;
export {
  TimePicker_default as default
};
